import { IgrColumnGroupDescriptionCollection } from "./igr-column-group-description-collection";
import { GridGroupDescriptionsChangedEventArgs as GridGroupDescriptionsChangedEventArgs_internal } from "./GridGroupDescriptionsChangedEventArgs";
/**
 * Information about the current grouping applied to the grid.
*/
var IgrGridGroupDescriptionsChangedEventArgs = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridGroupDescriptionsChangedEventArgs() {
        this._implementation = this.createImplementation();
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    }
    IgrGridGroupDescriptionsChangedEventArgs.prototype.createImplementation = function () {
        return new GridGroupDescriptionsChangedEventArgs_internal();
    };
    Object.defineProperty(IgrGridGroupDescriptionsChangedEventArgs.prototype, "i", {
        /**
         * @hidden
         */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    IgrGridGroupDescriptionsChangedEventArgs.prototype.onImplementationCreated = function () {
    };
    IgrGridGroupDescriptionsChangedEventArgs.prototype._provideImplementation = function (i) {
        this._implementation = i;
        this._implementation.externalObject = this;
        this.onImplementationCreated();
    };
    Object.defineProperty(IgrGridGroupDescriptionsChangedEventArgs.prototype, "groupDescriptions", {
        get: function () {
            if (this.i.groupDescriptions == null) {
                return null;
            }
            if (!this.i.groupDescriptions.externalObject) {
                var e = new IgrColumnGroupDescriptionCollection();
                e._implementation = this.i.groupDescriptions;
                this.i.groupDescriptions.externalObject = e;
            }
            return this.i.groupDescriptions.externalObject;
        },
        set: function (v) {
            v == null ? this.i.groupDescriptions = null : this.i.groupDescriptions = v.i;
        },
        enumerable: true,
        configurable: true
    });
    return IgrGridGroupDescriptionsChangedEventArgs;
}());
export { IgrGridGroupDescriptionsChangedEventArgs };
//# sourceMappingURL=igr-grid-group-descriptions-changed-event-args.js.map
